import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const AuthRedirectGuard = ({ children }) => {
    const isAuthenticated = () => Cookies.get('token') !== undefined;

    return isAuthenticated() ? <Navigate to="/space" replace /> : children;
};

export default AuthRedirectGuard;
